import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { MasterPlansRepository } from "../../repositories";
import { Observable } from "rxjs";
import { CommitPlanRequest } from "../../domain/requests/master-plan.ts/commit-plan.request";
import { TimeZones } from "../../domain/models/time-zones";

@Injectable({ providedIn: 'root' })
export class GetTimeZonesUseCase implements UseCase<null, TimeZones[]> {

  constructor(private readonly masterPlanRepository: MasterPlansRepository) {
  }

  execute(): Observable<TimeZones[]> {
    return this.masterPlanRepository.getTimeZones();
  }
}